import { Injectable } from '@angular/core';
import { Observable ,  Subject } from 'rxjs';

@Injectable()
export class LayoutService {
    public layout = new Subject();

    //Created this service for handling
    //different styling in the parent components
    //layout depending on which child component
    //you care viewing
    update(component): void {
        this.layout.next({ component : component });
    }

    getLayout(): Observable<any> {
        return this.layout.asObservable(); 
    }
}